<template>
    <div>
        <div class="project-correlation-container container mt-4">
            <div class="row mt-2 mb-5">
                <div class="col-md-8 col-sm-11 mx-auto">
                    <div>
                        <span class="num-of-correlations">{{ correlations.length }} correlations found </span>
                        <span class="explanation-icon"><i v-tooltip="getCorrelationExplanationTooltip()" class="far fa-question-circle"></i></span>
                        <span> {{ project.num_of_rows }}</span> records analyzed
                    </div>
                </div>
            </div>
            <div class="row mt-2 mb-3" v-if="correlations">
                <div class="col mx-auto list-column">
                    <ul class="text-center correlation-results">
                        <li class="text-left pl-2" v-for="correlation in correlations">
                            <p><span
                                class="correlation-icon"><i v-tooltip="getListIconTooltipTitle(correlation)"
                                                            v-bind:class="['fas', getCorrelationIconClass(correlation)]"></i></span>
                                "<b>{{ correlation.column1 }}</b>" is {{ getCorrelationVerb(correlation) }}
                                "<b>{{ correlation.column2 }}</b>"
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <modal-component></modal-component>
        </div>
        <project-results-preview-data v-bind:preview-data="previewData" v-bind:number-of-rows="numberOfRows"></project-results-preview-data>
    </div>
</template>
<script>

    import {mapActions, mapGetters} from 'vuex';

    export default {
        props: {
            project: Object
        },
        mounted() {
            this.getCorrelationResultsFromAPI();
        },
        data: function () {
            return {
                correlations: [],
                numberOfRows: 0,
                previewData: {
                    headers: [],
                    rows: []
                }
            }
        },
        computed: {},
        methods: {
            ...mapActions([
                'closeModal',
                'openModal',
                'setLoading',
                'setMessage',
                'setModalAllowClose',
                'requestRecipeFromAPI',
                'handleError'
            ]),

            getCorrelationResultsFromAPI() {
                let instance = this;
                instance.requestRecipeFromAPI(instance.project)
                    .then(function (response) {
                        console.log('got response', response);
                        const rows = response.data.parsedCSV.rows;
                        instance.numberOfRows = response.data.parsedCSV.numberOfRows;
                        instance.previewData.headers = response.data.parsedCSV.headers;
                        instance.previewData.rows = rows;
                        instance.correlations = response.data.correlations;
                    })
                    .catch(function (error) {
                        console.log('got error', error);
                        instance.handleError(error)
                    });
            },
            getCorrelationExplanationTooltip() {
                return '<ul class="correlation-explanation-list"><li><i class="fas fa-equals"></i><b>Neutral correlation</b> means that two components are related in a contextual way to each other</li>' +
                    '<li><i class="fas fa-chevron-up"></i><b>Direct correlation</b> means that two components increase or decrease with each other</li>' +
                    '<li><i class="fas fa-chevron-down"></i><b>Inverse correlation</b> means that while one component increases, the other decreases and vice-versa</li></ul>'
            },
            getCorrelationVerb(correlation) {
                if (!correlation.canProportionalityBeDefined)
                    return 'correlated with';
                if (correlation.correlation > 0)
                    return 'directly proportional to';
                return 'inversely proportional to';
            },
            getCorrelationIconClass(correlation) {
                if (!correlation.canProportionalityBeDefined)
                    return 'fa-equals';
                if (correlation.correlation > 0)
                    return 'fa-chevron-up';
                return 'fa-chevron-down';
            },
            getListIconTooltipTitle(correlation) {

                if (!correlation.canProportionalityBeDefined)
                    return 'Neutral correlation';
                if (correlation.correlation > 0)
                    return 'Direct correlation';
                return 'Inverse correlation';
            }
        }
    }

</script>
<style lang="scss">

    @import "../../sass/variables";

    .positive {
        color: $green;
    }

    .negative {
        color: $red;
    }

    .neutral {
        color: $orange;
    }

    .project-correlation-container {
        background-color: #EBFEFF;
        padding-top: 2rem;
        padding-bottom: 2rem;
    }

    .list-column {
        display: flex;
        justify-content: center;
    }

    .correlation-icon {
        margin-right: 8px;

        &:hover {
            cursor: pointer;
            opacity: 0.7;
        }
    }

    .correlation-results, .correlation-explanation-list {
        list-style-type: none;
    }

    .correlation-explanation-list {
        i {
            margin-right: 20px;
        }
    }

    .num-of-correlations {
        font-weight: 400;
        color: $blue;
        font-size: 1.5rem;
    }

    .explanation-icon {
        margin-right: 20px;
        font-size: 1.2rem;

        &:hover {
            cursor: pointer;
            opacity: 0.7;
        }
    }

    .tooltip-vue {
        .tooltip-vue-inner {
            background-color: #ffffff;
            border: 1px solid $grey;
            padding: 20px;
            color: $blue;
            font-weight: 300;

            li {
                margin-top: 15px;
            }
        }
    }

</style>
